<svg
  class="stroke-base-600 absolute right-[30px] h-[16px] w-[16px] cursor-pointer"
  (click)="closed.emit()"
>
  <use xlink:href="#close-modal"></use>
</svg>
